const shelfBtnAddon = () => {
  const shelfAddToCartBtn = document.querySelector('[data-add-to-cart]');
  const addShelfBtn = document.querySelector('input[value="addShelf"]');
  const noShelfBtn = document.querySelector('input[value="noShelf"]');
  const shelfBtns = document.querySelectorAll('input[name="shelfRadioBtn"]');
  
  const colorBtns = document.querySelectorAll('input[name="items[1][id]"]');
  const price = document.querySelector('[data-price-container]');
  const names = document.querySelectorAll('[data-name-container]');
  
  const shelfContainer = document.querySelector('.choose-shelf-container');
  const shelfHeading = document.querySelector('.choose-shelf-heading');
  const colorContainer = document.querySelector('.choose-shelf-container__options');

  
  shelfAddToCartBtn.addEventListener('click', (e) => {
    // logik der tjekker de felter der skal være required
    if (addShelfBtn.checked === false && noShelfBtn.checked === false) {
      // hvis der er en fejl, så vis fejlbesked og fejl styling og 
      // e.preventDefault();
      shelfContainer.style.border = "1px solid red";
      shelfHeading.style.color = "red";
      shelfAddToCartBtn.setAttribute("type", "button");
    } else {
      shelfAddToCartBtn.setAttribute("type", "submit");
    }
    // ellers gør intet - for så submitter den selv
  });
  

  // Tilføj listener på skift mellem parent radios
  // -> rammer man "Nej tak" sættes child radios til disabled
  shelfBtns.forEach(shelfBtn => {
    shelfBtn.addEventListener('change', (e) => {
      if (e.target.value === "noShelf" && e.target.checked === true) {
        addShelfBtn.checked = false;
        shelfContainer.style.border = "1px solid #E5E5E5";
        shelfHeading.style.color = "#000";
        colorContainer.setAttribute('hidden', '');
        colorBtns.forEach(colorBtn => {
          colorBtn.disabled = true;
        });
      } else if (e.target.value === "addShelf" && e.target.checked === true) {
        noShelfBtn.checked = false;
        shelfContainer.style.border = "1px solid #E5E5E5";
        shelfHeading.style.color = "#000";
        colorContainer.removeAttribute('hidden');
        colorBtns.forEach(colorBtn => {
          colorBtn.disabled = false;
        });
      } else if (e.target.value === "addShelf" && e.target.checked === false) {
        shelfContainer.style.border = "1px solid #E5E5E5";
        shelfHeading.style.color = "#000";
        colorContainer.setAttribute('hidden', '');
        colorBtns.forEach(colorBtn => {
          colorBtn.disabled = true;
        });
      }
    });
  });

  // Tilføj listener på skift mellem child radios
  // -> opdatér data-price med child radio data-price (element.textContent = e.target.dataset.price)
  colorBtns.forEach(colorBtn => {
    colorBtn.addEventListener('change', (e) => {
      price.innerHTML = `+${e.target.dataset.price}`;
      names.forEach(name => {
        name.innerHTML = e.target.dataset.name.split('-')[0];
      });
    });
  });
}

shelfBtnAddon();